import { render, staticRenderFns } from "./DefinitionTip.vue?vue&type=template&id=08a75844"
import script from "./DefinitionTip.vue?vue&type=script&lang=js"
export * from "./DefinitionTip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports